import { render, staticRenderFns } from "./reminderOperation.vue?vue&type=template&id=1bec0c0b&"
import script from "./reminderOperation.vue?vue&type=script&lang=ts&"
export * from "./reminderOperation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports